import { render, staticRenderFns } from "./CartaoInformacoesDadosCadastrais.vue?vue&type=template&id=235f6482&scoped=true"
import script from "./CartaoInformacoesDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesDadosCadastrais.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesDadosCadastrais.vue?vue&type=style&index=0&id=235f6482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f6482",
  null
  
)

export default component.exports